import useSWR from 'swr';
import { FEATURE_FLAGS } from '../config';
import axiosSWRFetcher from '../utils/swrFetcher';
import axios from '../utils/axios';

// 폴더 목록 조회
export const useEmailFolders = () =>
  useSWR(
    FEATURE_FLAGS.CREW_EMAIL_ENABLED ? '/api/crews/emails/folders/' : null,
    axiosSWRFetcher,
    { revalidateOnFocus: false }
  );

// 이메일 목록 조회
export const useEmailList = (folder = 'INBOX', page = 1, search = '', enabled = true) => {
  const params = new URLSearchParams({ folder, page, page_size: '20' });
  if (search) params.append('search', search);

  return useSWR(
    FEATURE_FLAGS.CREW_EMAIL_ENABLED && enabled ? `/api/crews/emails/?${params}` : null,
    axiosSWRFetcher,
    { revalidateOnFocus: false }
  );
};

// 이메일 상세 조회 (스레드)
export const useEmailDetail = (uid, folder = 'INBOX') =>
  useSWR(
    uid && FEATURE_FLAGS.CREW_EMAIL_ENABLED ? `/api/crews/emails/${uid}/?folder=${folder}` : null,
    axiosSWRFetcher,
    { revalidateOnFocus: false }
  );

// 스레드 직접 조회
export const useEmailThread = (threadId, focusedUid = null) => {
  const params = focusedUid ? `?focused_uid=${focusedUid}` : '';
  return useSWR(
    threadId && FEATURE_FLAGS.CREW_EMAIL_ENABLED
      ? `/api/crews/emails/thread/${threadId}/${params}`
      : null,
    axiosSWRFetcher,
    { revalidateOnFocus: false }
  );
};

// 이메일 발송
export const sendEmail = async (data) => {
  const response = await axios.post('/api/crews/emails/send/', data);
  return response.data;
};

// 이메일 답장
export const replyEmail = async (uid, data) => {
  const response = await axios.post(`/api/crews/emails/${uid}/reply/`, data);
  return response.data;
};

// 이메일 전달
export const forwardEmail = async (uid, data) => {
  const response = await axios.post(`/api/crews/emails/${uid}/forward/`, data);
  return response.data;
};

// 읽음 표시
export const markAsRead = async (uid, isRead = true) => {
  const response = await axios.post(`/api/crews/emails/${uid}/read/`, { is_read: isRead });
  return response.data;
};

// 별표 표시
export const toggleStar = async (uid, isStarred) => {
  const response = await axios.post(`/api/crews/emails/${uid}/star/`, { is_starred: isStarred });
  return response.data;
};

// 이메일 삭제
export const deleteEmail = async (uid, folder = 'INBOX') => {
  const response = await axios.delete(`/api/crews/emails/${uid}/delete/?folder=${folder}`);
  return response.data;
};

// 이메일 이동
export const moveEmail = async (uid, fromFolder, toFolder) => {
  const response = await axios.post(`/api/crews/emails/${uid}/move/`, {
    from_folder: fromFolder,
    to_folder: toFolder,
  });
  return response.data;
};

// 첨부파일 업로드 URL 발급
export const getPresignedUrl = async (filename, contentType) => {
  const response = await axios.post('/api/crews/emails/attachments/presigned/', {
    filename,
    content_type: contentType,
  });
  return response.data;
};

// S3에 파일 업로드
export const uploadToS3 = async (uploadUrl, file) => {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });
  return response.ok;
};
